import { highlights } from '@/mocks/data';

export default function Highlights() {
  return (
    <section className="w-full px-6 md:px-10 py-14 md:py-18 bg-background-900">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {highlights.map((item, i) => (
            <div key={i} className="text-center">
              <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">
                {item.value}
              </p>
              <p className="text-sm font-semibold text-background-300 mb-1">
                {item.label}
              </p>
              <p className="text-xs text-background-500">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}